var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSharePrimary2020 = function SvgSharePrimary2020(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "share_primary_20_20_svg__a",
    width: 20,
    height: 20,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#share_primary_20_20_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3177FF",
    d: "M5.256 18.75q-.63 0-1.069-.438a1.45 1.45 0 0 1-.437-1.069V8.59q0-.632.438-1.07a1.45 1.45 0 0 1 1.068-.437h2.132v1.25H5.256a.25.25 0 0 0-.176.08.25.25 0 0 0-.08.177v8.654q0 .096.08.176t.176.08h9.488a.24.24 0 0 0 .176-.08.24.24 0 0 0 .08-.177V8.59a.25.25 0 0 0-.08-.177.25.25 0 0 0-.177-.08h-2.13v-1.25h2.13q.633 0 1.07.438.437.437.437 1.069v8.654q0 .63-.437 1.068a1.45 1.45 0 0 1-1.07.438zm4.119-5.625V3.933L7.833 5.474l-.878-.89L10 1.537l3.045 3.045-.878.891-1.542-1.541v9.192z"
  }))));
};
export default SvgSharePrimary2020;